import React,{Component} from 'react'
import AOS from 'aos'


export default class MiniProtal extends Component{
    componentDidMount() {
        this.aos = AOS;
        this.aos.init({
            duration: 1500,
            once: true,
        });
    }
    componentDidUpdate() {
        this.aos.refresh();
    }
    render(){
        return <div>MiniProtal</div>
    }
}


// WEBPACK FOOTER //
// ./src/components/mini_portal_components/mini_portal.js